import {
  isArabicLanguage,
  localizedNumber,
} from "../localization/localization";

type EarnedPoints = {
  total: number;
  base: number;
};

type TranslateFn = (key: string, options?: Record<string, string>) => string;

export const formatPlusPoints = (points: number): string => {
  const formatted = localizedNumber(points);

  return isArabicLanguage() ? `${formatted}+` : `+${formatted}`;
};

export const buildLoyaltyMultiplierBannerDescription = (
  t: TranslateFn,
  earned: EarnedPoints | undefined
): string => {
  if (!earned?.total || !earned?.base) {
    return "";
  }

  return t("offers:multiplier-cart-banner-description", {
    earnedTotal: formatPlusPoints(earned.total),
    earnedBase: localizedNumber(earned.base),
    insteadOf: t("common:instead-of"),
    pointsLabel: t("offers:points"),
  });
};

// The bill's "You earned" line is points, not money — the value is returned as a
// pre-formatted string so BillTable renders it verbatim instead of prefixing a currency.
export const buildEarnedPointsLabel = (
  t: TranslateFn,
  points: number | undefined
): string => {
  if (!points || points <= 0) {
    return "";
  }

  return `${formatPlusPoints(points)} ${t("offers:points")}`;
};
